import React, { useState, useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const ClassCard = ({ imageUrl, category, title, Description, duration, youtubeUrl }) => (
    <div className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer hover:shadow-lg transition-shadow duration-300 h-full flex flex-col" onClick={() => window.open(youtubeUrl, "_blank")} role="button" tabIndex={0}>
        <div className="relative">
            <img src={imageUrl} alt={title} className="w-full h-50 lg:h-50 object-fill" />
            {/* <div className="absolute top-2 right-2 bg-white rounded-full px-2 py-1 flex items-center shadow-sm">
                <span className="text-xs font-medium">{duration}</span>
            </div> */}
        </div>
        <div className="p-4 flex flex-col flex-1">
            <div>
                <span className="inline-block text-sm font-medium text-[#4267B2] bg-blue-50 border border-[#4267B2] px-3 py-1 rounded-full whitespace-nowrap">{category}</span>
            </div>
            <h3 className="text-lg font-medium mt-2 line-clamp-2">{title}</h3>
            <p className="flex-1 text-sm text-gray-600 mt-2">{Description}</p>
        </div>
    </div>
);

const SampleClasses = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [slidesToShow, setSlidesToShow] = useState(3);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const containerRef = useRef(null);
    const startX = useRef(0);
    const currentX = useRef(0);
    const isDragging = useRef(false);

    const classes = [
        {
            imageUrl: "https://www.drishtiias.com/images/uploads/1749222202_Vikas%20Sir%20(1).jpg",
            category: "Vikas Sir",
            title: "1971 India-Pak War to Operation Sindoor",
            Description: "1971 India-Pak War to Operation Sindoor | Concept Talk by Dr. Vikas Divyakirti | Drishti IAS",
            duration: "68 mins",
            youtubeUrl: "https://www.youtube.com/watch?v=KF7MOJd8jng",
        },
        {
            imageUrl: "https://www.drishtiias.com/images/uploads/1749222202_Vikas%20Sir%20(2).jpg",
            category: "Vikas Sir",
            title: "Pahalgam Attack",
            Description: "Pahalgam Attack | Decision-Making in Times of Crisis | Dr Vikas Divyakirti",
            duration: "26 mins",
            youtubeUrl: "https://www.youtube.com/watch?v=UsCyfHdEG6o",
        },
        {
            imageUrl: "https://www.drishtiias.com/images/uploads/1749228524_IAS%20Optional%20(1).jpg",
            category: "IAS",
            title: "UPSC History Optional",
            Description: "UPSC History Optional | Preparation & Strategy by Mr. D.K. Pandey | Drishti IAS",
            duration: "10 mins",
            youtubeUrl: "https://www.youtube.com/watch?v=gV0T9apZs1k",
        },
        {
            imageUrl: "https://www.drishtiias.com/images/uploads/1749228524_IAS%20Optional%20(2).jpg",
            category: "IAS",
            title: "UPSC Philosophy Optional",
            Description: "UPSC Philosophy Optional | Preparation & Strategy by Dr. Ambuj Srivastava | Drishti IAS EnglishGS Foundation Course for UPSC CSE 2026 | PRELIMS + MAINS | Explained by B. · IAS GS Foundation Course at 40% Discount | Drishti IAS English.",
            duration: "20 mins",
            youtubeUrl: "https://www.youtube.com/watch?v=uzw2sYliEoQ",
        },
        {
            imageUrl: "https://www.drishtiias.com/images/uploads/1749228539_IAS%20Optional%20(3).jpg",
            category: "IAS",
            title: "UPSC Anthropology Optional ",
            Description: "UPSC Anthropology Optional | Preparation & Strategy by Dr. C.P. Kaushik | UPSC | Drishti IAS English",
            duration: "50 mins",
            youtubeUrl: "https://www.youtube.com/watch?v=5xbaMqbJ7lc",
        },
        {
            imageUrl: "https://www.drishtiias.com/images/uploads/1749228539_IAS%20Optional%20(4).jpg",
            category: "IAS",
            title: "UPSC PSIR  Optional",
            Description: "UPSC PSIR  Optional | Preparation & Strategy by Dr. Ashutosh Jha | UPSC | Drishti IAS English",
            duration: "45 mins",
            youtubeUrl: "https://www.youtube.com/watch?v=LjjrBEkLGjY",
        },
        {
            imageUrl: "https://www.drishtiias.com/images/uploads/1749229741_PCS%201.jpg",
            category: "PCS",
            title: "MPSC Rajyaseva 2025",
            Description: "MPSC Rajyaseva 2025 | Complete Exam Pattern, Strategy & Course Details | Drishti PCS",
            duration: "75 mins",
            youtubeUrl: "https://www.youtube.com/watch?v=Bbqit27Cizs",
        },
        {
            imageUrl: "https://www.drishtiias.com/images/uploads/1749229741_PCS%202.jpg",
            category: "PCS",
            title: "Punjab PCS 2025 Prelims — Syllabus & Exam Pattern",
            Description: "Punjab PCS 2025 Prelims — Syllabus & Exam Pattern | Punjab Civil Services | Punjab PSC | Drishti PCS",
            duration: "60 mins",
            youtubeUrl: "https://www.youtube.com/watch?v=_eGbfvaGOVk",
        },
        {
            imageUrl: "https://www.drishtiias.com/images/uploads/1749229747_PCS%203.jpg",
            category: "PCS",
            title: "Key Tips by UPPCS Topper Siddharth Gupta, Rank 1 ",
            Description: "Key Tips by UPPCS Topper Siddharth Gupta, Rank 1 | Strategy for UPPCS Exam 2024 | Drishti PCS",
            duration: "10 mins",
            youtubeUrl: "https://www.youtube.com/watch?v=Je9vnLUBFCg",
        },
        {
            imageUrl: "https://www.drishtiias.com/images/uploads/1749229549_Judiciary%201.jpg",
            category: "Judiciary",
            title: "Seminar on 3 Year Practice Rule",
            Description: "Seminar on 3 Year Practice Rule | Positive Approach Seminar | Drishti Judiciary",
            duration: "20 mins",
            youtubeUrl: "https://www.youtube.com/watch?v=dhadS5UtgPk",
        },
        {
            imageUrl: "https://www.drishtiias.com/images/uploads/1749229559_Judiciary%202.jpg",
            category: "Judiciary",
            title: "Bail in BNSS (new CrPC)",
            Description: "Bail in BNSS (new CrPC) | Drishti Judiciary",
            duration: "50 mins",
            youtubeUrl: "https://www.youtube.com/watch?v=czSuGGwtaDU",
        },
        {
            imageUrl: "https://www.drishtiias.com/images/uploads/1749229561_Judiciary%203.jpg",
            category: "Judiciary",
            title: "Introduction to CLAT",
            Description: "Introduction to CLAT | CLAT Exam | CLAT Exam Preparation Strategy | Drishti Judiciary",
            duration: "45 mins",
            youtubeUrl: "https://www.youtube.com/watch?v=dVfNdowNURM",
        },
        {
            imageUrl: "https://www.drishtiias.com/images/uploads/1749229548_Judiciary%204.jpg",
            category: "Judiciary",
            title: "How to Read Bare Acts?",
            Description: "How to Read Bare Acts? | Drishti Judiciary",
            duration: "56 mins",
            youtubeUrl: "https://www.youtube.com/watch?v=5JKNRxwY_6k",
        },
    ];

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 640) setSlidesToShow(1);
            else if (window.innerWidth < 1024) setSlidesToShow(2);
            else setSlidesToShow(3);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const autoSlide = setInterval(() => {
            if (!isDragging.current) {
                nextSlide();
            }
        }, 10000);
        return () => clearInterval(autoSlide);
    }, [currentIndex, slidesToShow]);

    const nextSlide = () => {
        if (isTransitioning) return;
        setIsTransitioning(true);
        setCurrentIndex((prevIndex) => {
            const newIndex = prevIndex + slidesToShow >= classes.length ? 0 : prevIndex + slidesToShow;
            return newIndex;
        });
        setTimeout(() => setIsTransitioning(false), 700);
    };

    const prevSlide = () => {
        if (isTransitioning) return;
        setIsTransitioning(true);
        setCurrentIndex((prevIndex) => {
            const newIndex = prevIndex - slidesToShow < 0 ? Math.max(classes.length - slidesToShow, 0) : prevIndex - slidesToShow;
            return newIndex;
        });
        setTimeout(() => setIsTransitioning(false), 700);
    };

    const goToSlide = (index) => {
        if (isTransitioning) return;
        setCurrentIndex(index);
    };

    const handleStart = (e) => {
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        startX.current = clientX;
        isDragging.current = true;

        if (!e.touches) {
            e.preventDefault();
        }
    };

    const handleMove = (e) => {
        if (!isDragging.current) return;
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        currentX.current = clientX;
    };

    const handleEnd = () => {
        if (!isDragging.current) return;

        const diffX = startX.current - currentX.current;
        const threshold = 50;

        if (Math.abs(diffX) > threshold) {
            if (diffX > 0) {
                nextSlide();
            } else {
                prevSlide();
            }
        }

        isDragging.current = false;
    };

    const handleMouseLeave = () => {
        if (isDragging.current) {
            isDragging.current = false;
        }
    };

    return (
        <div className="w-full flex justify-center items-center py-12 px-4 sm:px-12 lg:px-8 bg-gradient-to-br from-blue-50">
            <div className="max-w-7xl w-full relative">
                <h2 className="text-3xl font-bold text-center mb-2">
                    <span className="text-[#4267B2]">Sample</span> Classes
                </h2>
                <p className="text-center text-gray-600 mb-8 max-w-2xl mx-auto">Register on Drishti Learning App to Watch FREE Sample Classes of any Course you want to purchase</p>
                <div className="relative flex items-center">
                    <button
                        onClick={prevSlide}
                        className="hidden md:flex items-center justify-center absolute left-[-40px] top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:shadow-lg transition-shadow z-20 border border-gray-200"
                        aria-label="Previous Slide"
                        style={{ width: 44, height: 44 }}
                    >
                        <ChevronLeft size={24} />
                    </button>

                    <div className="w-full overflow-hidden">
                        <div
                            ref={containerRef}
                            className="flex w-full mb-10 transition-transform duration-700 ease-in-out cursor-grab active:cursor-grabbing select-none"
                            style={{
                                transform: `translateX(-${(currentIndex * 100) / slidesToShow}%)`,
                            }}
                            onTouchStart={handleStart}
                            onTouchMove={handleMove}
                            onTouchEnd={handleEnd}
                            onMouseDown={handleStart}
                            onMouseMove={handleMove}
                            onMouseUp={handleEnd}
                            onMouseLeave={handleMouseLeave}
                        >
                            {classes.map((classItem, idx) => (
                                <div
                                    key={idx}
                                    className="flex-shrink-0 px-2"
                                    style={{
                                        width: `${100 / slidesToShow}%`,
                                        minWidth: 0,
                                    }}
                                >
                                    <ClassCard {...classItem} />
                                </div>
                            ))}
                        </div>
                    </div>

                    <button
                        onClick={nextSlide}
                        className="hidden md:flex items-center justify-center absolute right-[-40px] top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:shadow-lg transition-shadow z-20 border border-gray-200"
                        aria-label="Next Slide"
                        style={{ width: 44, height: 44 }}
                    >
                        <ChevronRight size={24} />
                    </button>
                </div>

                <div className="flex justify-center mt-4">
                    {Array.from({ length: Math.ceil(classes.length / slidesToShow) }).map((_, idx) => (
                        <button
                            key={idx}
                            onClick={() => goToSlide(idx * slidesToShow)}
                            className={`w-3 h-3 mx-2 rounded-full transition-colors duration-300 ${currentIndex === idx * slidesToShow ? "bg-[#4267B2]" : "bg-gray-300"}`}
                            aria-label={`Go to slide ${idx + 1}`}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SampleClasses;
